import { Buffer } from 'buffer';

export const getFormattedStringFromFile = async (file: File, format: BufferEncoding = 'base64'): Promise<string> => {
  const fileBuffer = await file.arrayBuffer();
  const r = Buffer.from(fileBuffer).toString(format);
  return r;
};
